import { ReactNode, useId } from "react"
import { resolveCardImageSource } from "@/constants/cardAssets"

const SHAPE_BORDER_COLOR = "rgba(255,255,255,0.32)"
const SHAPE_BORDER_WIDTH = 1.5

type ImageAlign = "center" | "top" | "bottom"

const SVG_PRESERVE: Record<ImageAlign, string> = {
  center: "xMidYMid slice",
  top: "xMidYMin slice",
  bottom: "xMidYMax slice",
}

interface CardShapeLayerProps {
  width: number
  height: number
  path: string
  fill?: string
  imageSource?: string | null
  imageAlign?: ImageAlign
  left?: number
  top?: number
  imageReplayKey?: string | number
  className?: string
  children?: ReactNode
}

export default function CardShapeLayer({
  width,
  height,
  path,
  fill,
  imageSource,
  imageAlign = "center",
  left = 0,
  top = 0,
  imageReplayKey,
  className,
  children,
}: CardShapeLayerProps) {
  const href = resolveCardImageSource(imageSource)
  const clipId = `card-shape-${useId().replace(/:/g, "")}`

  return (
    <div
      className={className}
      style={{
        position: "absolute",
        left,
        top,
        width,
        height,
        overflow: "hidden",
      }}
    >
      <svg width={width} height={height} className="block">
        <defs>
          <clipPath id={clipId}>
            <path d={path} />
          </clipPath>
        </defs>
        {fill ? <path d={path} fill={fill} /> : null}
        {href ? (
          <image
            href={href}
            x={0}
            y={0}
            width={width}
            height={height}
            preserveAspectRatio={SVG_PRESERVE[imageAlign]}
            clipPath={`url(#${clipId})`}
            key={imageReplayKey ?? href}
          />
        ) : !fill ? (
          <path d={path} fill="#27252B" />
        ) : null}
        <path
          d={path}
          fill="none"
          stroke={SHAPE_BORDER_COLOR}
          strokeWidth={SHAPE_BORDER_WIDTH}
        />
      </svg>
      {children ? (
        <div className="pointer-events-none absolute inset-0">{children}</div>
      ) : null}
    </div>
  )
}
